module.exports = __webpack_public_path__ + "static/media/COCINANDO EN CASA.54304387.jpg";